import { render, staticRenderFns } from "./boxesScanIn.vue?vue&type=template&id=1acad6ca&scoped=true&"
import script from "./boxesScanIn.vue?vue&type=script&lang=js&"
export * from "./boxesScanIn.vue?vue&type=script&lang=js&"
import style0 from "./boxesScanIn.vue?vue&type=style&index=0&id=1acad6ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acad6ca",
  null
  
)

component.options.__file = "boxesScanIn.vue"
export default component.exports